import useAuth from "../../hooks/useAuth";
import {useEffect, useState} from "react";
import {createProduct} from "../../api/admin/productReq";
import FormInputs from "../FormInputs";
import useData from "../../hooks/useData";
import FormButtons from "../../components/common/FormButtons";
import {getErrorListFromValidation, patternListChoices, removeErrorList, validateFormInput} from "../../helper/tools";
import Icon from "../../components/common/Icon";

export default function FormProduct({ apiProductList, legend, setShowModal }) {
    const { auth } = useAuth();
    const token = auth.token;
    const { productInfos } = useData();
    const [values, setValues] = useState(productInfos);

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
        validateFormInput(e)
    };

    useEffect(() => {
        if (productInfos) {
            setValues(productInfos)
        }
    }, [ productInfos ]);


    const handleSubmit = async (e) => {
        e.preventDefault()
        let body = {
            id : values?.id,
            name : values?.name,
            type : values?.type ? values?.type : 0,
            defaultPrice: parseFloat(values?.defaultPrice),
            defaultPercent: parseFloat(values?.defaultPercent),
            advisedResellPrice: parseFloat(values?.advisedResellPrice),
        }

        await createProduct(token, body)
            .then(response => {
                removeErrorList()
                if(!response?.response?.data?.error) {
                    setShowModal(false)
                    apiProductList()
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }

    const handleRemoveModal = () => {
        setShowModal(false)
    };

    const inputs = [
        {
            id : 1,
            name : "name",
            type : "text",
            placeholder : "Nom du produit",
            label : "Nom du produit",
            required : true,
            pattern : `^[a-zA-Z0-9àâäéèêëîïôöùûüç\\-\\s']+$`
        },
        {
            id : 2,
            name : "defaultPrice",
            type : "text",
            placeholder : "Prix par défaut",
            label : "Prix par défaut",
            required: true,
            pattern: patternListChoices?.price
        },
        {
            id : 3,
            name : "defaultPercent",
            type: "text",
            placeholder : "Reversement au réseau par défaut",
            label : "Reversement au réseau par défaut",
            required: true,
            pattern:  patternListChoices?.price
        },
        {
            id : 4,
            name : "advisedResellPrice",
            type: "text",
            placeholder : "Prix de vente conseillé",
            label : "Prix de vente conseillé",
            required: true,
            pattern:  patternListChoices?.price
        },
    ];

    return (
        <form onSubmit={handleSubmit} method="POST" noValidate>
            <fieldset>
                {(legend !== "no-legend") && <Icon span={legend} source="fa-solid fa-cubes" />}
                {inputs.map(input => (
                    <FormInputs
                        type={input.type}
                        name={input.name}
                        id={input.id}
                        label={input.label}
                        placeholder={input.placeholder}
                        value={values[input.name]}
                        onChange={onChange}
                        required={input.required}
                        options={input.options}
                        selected={input.selected}
                        checked={input.checked}
                        key={input.id + input.name}
                        pattern={input.pattern}
                    />
                ))}
                <div className="errors"></div>
            </fieldset>
            <FormButtons handleRemoveModal={handleRemoveModal}/>
        </form>
    );
}